"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_2 = require("react");

exports.HubSpotForm = function (_a) {
  var portalId = _a.portalId,
      formId = _a.formId;
  react_2.useEffect(function () {
    if (window && document) {
      var script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      document.body.appendChild(script);
      script.addEventListener('load', function () {
        if (window && window.hbspt) {
          window.hbspt.forms.create({
            portalId: portalId,
            formId: formId,
            target: '#hub-' + formId
          });
        }
      });
    }
  }, [portalId, formId]);
  return react_1.default.createElement("div", {
    id: 'hub-' + formId
  });
};